import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import i18next from 'i18next';

import { formatDate } from 'src/utils/format-date';
import { selectUserChoices } from 'src/store/slices/payment-plan-slice';
import { selectRoom } from 'src/store/slices/booking-slice';
import { getStorage } from 'src/utils/local-storage-versioning';

import { styles } from './styles';

export const BookingDetailsContent: FC = () => {
    const { t } = useTranslation();

    const userChoices = useSelector(selectUserChoices);
    const roomData = useSelector(selectRoom);
    const storage = getStorage();

    const { paymentPlanId = null } = storage.redirectState;

    if (
        !userChoices.term ||
        !userChoices.instalmentType ||
        !userChoices.numberOfStudents ||
        !roomData
    )
        return null;

    const count = userChoices.term.duration;
    const bookingSummaryKey =
        roomData.monthly_price && !paymentPlanId
            ? 'booking_summary_months_count'
            : 'booking_summary_weeks_count';

    return (
        <Box css={styles.detailsWrapper}>
            {[
                {
                    header: t('your_details_booking_length'),
                    content: t(bookingSummaryKey, {
                        count,
                    }),
                },
                {
                    header: t('your_details_booking_start_date'),
                    content: formatDate(userChoices.term.startDate),
                },
                {
                    header: t('your_details_booking_end_date'),
                    content: formatDate(userChoices.term.endDate),
                },
                {
                    header: t('your_details_booking_students_count'),
                    content: `${i18next.t('your_details_student_count', { count: userChoices.numberOfStudents })}`,
                },
                {
                    header: t('your_details_booking_instalment_plan'),
                    content: userChoices.instalmentType,
                },
            ].map((item) => (
                <Box key={item.header} css={styles.subContainer}>
                    <Typography variant="h4" css={styles.subContainerHeader}>
                        {item.header}
                    </Typography>
                    <Typography variant="h4" css={styles.subContainerContent}>
                        {item.content}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};
